exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.profile-picture[data-v-37e5bba1]{height:100%}div.content[data-v-37e5bba1]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}div.croppa-container[data-v-37e5bba1]{border:1px solid #000;border-radius:10px;border-style:dashed;width:200px;height:200px;margin:auto;overflow:hidden}", ""]);

// exports
